<template>
  <div class="carousel" :class="outerClasses">
    <v-carousel
      :adjustable-height="adjustableHeight"
      :per-page-custom="perPageCustom"
      :pagination-enabled="paginationEnabled"
      :autoplay="autoplay"
      :autoplayTimeout="autoplayTimeout"
      :loop="loop"
      @page-change="updatePageNumber"
      @transition-end="transitionEnd"
      ref="carousel"
    >
      <slot :carousel="scopedSlots" />
    </v-carousel>

    <div
      class="carousel-nav"
      :class="{ 'carousel-nav--fewer': numberOfSlides <= 5 }"
    >
      <slot name="navigation" :carousel="scopedSlots"></slot>
    </div>

    <div class="carousel-dots">
      <slot name="dots" :carousel="scopedSlots"></slot>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    "v-carousel": Carousel,
    "v-slide": Slide,
  },
  props: {
    outerClasses: {
      type: String,
      required: false,
      default: () => "",
    },
    adjustableHeight: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    numberOfSlides: {
      type: Number,
      required: true,
    },
    perPageCustom: {
      type: Array,
      required: false,
      default: () => [
        [320, 1],
        [848, 2],
        [1064, 5],
      ],
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    autoplayTimeout: {
      type: Number,
      required: false,
      default: () => 3000,
    },
    loop: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    paginationEnabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      canAdvanceForward: true,
      canAdvanceBackward: false,
      currentPage: 0,
    };
  },
  computed: {
    scopedSlots() {
      return {
        goToPrevPage: this.goToPrevPage,
        goToNextPage: this.goToNextPage,
        goToPage: this.goToPage,
        currentPage: this.currentPage,
        canAdvanceForward: this.canAdvanceForward,
        canAdvanceBackward: this.canAdvanceBackward,
        onSlideClick: this.onSlideClick,
      };
    },
  },
  methods: {
    goToPrevPage() {
      const prevPageIndex = this.$refs.carousel.getPreviousPage();

      this.$refs.carousel.goToPage(prevPageIndex);
    },
    goToNextPage() {
      const nextPageIndex = this.$refs.carousel.getNextPage();

      this.$refs.carousel.goToPage(nextPageIndex);
    },
    goToPage(page) {
      this.$refs.carousel.goToPage(page);
    },
    updatePageNumber() {
      this.currentPage = this.$refs.carousel.currentPage;
      this.canAdvanceForward = this.$refs.carousel.canAdvanceForward;
      this.canAdvanceBackward = this.$refs.carousel.canAdvanceBackward;
    },
    onSlideClick() {
      $(document).trigger("slide-click", this.currentPage);
    },
    transitionEnd() {
      $(document).trigger("zb-navpoints:update");
    },
  },
};
</script>

<style lang="scss">
.VueCarousel-inner {
  margin-left: -8px;
  margin-right: -8px;
}

.VueCarousel-slide {
  padding-left: 8px;
  padding-right: 8px;
  user-select: auto;
}

.carousel__item {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  background-color: #e2e2e2;
  height: 150px;
}

.carousel-nav {
  display: contents;
}

.carousel-dots {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  bottom: 10px;
}
</style>
